// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_i2-0";